import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingVisitorForm({ updateLocation, users, visitorManager }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'visitor_ids',
          role: 'visitor',
          title: '访客管理人员',
          selectedUsers: visitorManager
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    visitorManager: selectors.getTeamRolesOfLocation(state, loc_id, 'visitor')
  };
}

export default connect(mapStateToProps)(LocationSettingVisitorForm);
